import { Box, Typography } from '@mui/material';

interface DetailRowProps {
  label: string;
  value: string | number | null;
}

export const DetailRow = ({ label, value }: DetailRowProps) => (
  <Box display="flex" py={1}>
    <Typography variant="subtitle1" fontWeight="bold" sx={{ minWidth: '250px' }}>
      {label}:
    </Typography>
    <Typography variant="body1">{value || '-'}</Typography>
  </Box>
);
